import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import { useState, useEffect } from 'react';

export default function ComingSoon() {
  // Array of image URLs
  const images = [
    "https://www.sritakshashilagurukul.com/uploads/gallery_image8.jpeg",
    "https://www.sritakshashilagurukul.com/uploads/ISRO_1.jpg",
    "https://www.sritakshashilagurukul.com/uploads/ISRO_7.jpg",
    "https://www.sritakshashilagurukul.com/uploads/ISRO_8.jpg",
    "https://www.sritakshashilagurukul.com/uploads/ISRO_17.jpg",
    "https://www.sritakshashilagurukul.com/uploads/gallery_image12.jpeg",
    // Add more image URLs here
  ];

  // Randomly pick an image from the array
  const [backgroundImage, setBackgroundImage] = useState(images[Math.floor(Math.random() * images.length)]);

  // Optional: If you want the image to change at intervals (e.g., every 10 seconds)
  useEffect(() => {
    const interval = setInterval(() => {
      setBackgroundImage(images[Math.floor(Math.random() * images.length)]);
    }, 3000); // Change the image every 10000 milliseconds (10 seconds)

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="position-relative vh-100 d-flex align-items-center justify-content-center bg-dark text-white">
      <img 
        src={backgroundImage} 
        alt="Background" 
        className="position-absolute w-100 h-100" 
        style={{ objectFit: "cover", filter: "blur(12px)" }}
      />
      <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>
      <div className="position-relative text-center p-4">
        <h1 
          className="display-1 fw-bold mb-4 text-white animate__animated animate__fadeInDown animate__slow" 
          style={{ fontFamily: "'Playfair Display', serif", fontSize: "5rem" }}
        >
          Coming Soon!
        </h1>
        <p className="lead  bg-dark bg-opacity-75 p-3 rounded shadow-lg text-white animate__animated animate__fadeInUp animate__delay-1s">
          "Empowering young minds for a brighter future. Stay tuned for something impactful!"
        </p>
      </div>
    </div>
  );
}
